import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=7e304fe2&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e304fe2')) {
      api.createRecord('7e304fe2', component.options)
    } else {
      api.reload('7e304fe2', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=7e304fe2&", function () {
      api.rerender('7e304fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notice/notification.vue"
export default component.exports